import { createContext, useContext, useState, useCallback } from 'react';

const FilterContext = createContext();

export function FilterProvider({ children }) {
  const [region, setRegion] = useState('');
  const [step, setStep] = useState('');

  const clearFilters = useCallback(() => {
    setRegion('');
    setStep('');
  }, []);

  return (
    <FilterContext.Provider value={{ region, step, setRegion, setStep, clearFilters }}>
      {children}
    </FilterContext.Provider>
  );
}

export function useFilters() {
  const context = useContext(FilterContext);
  if (!context) throw new Error('useFilters must be used within FilterProvider');
  return context;
}
